import logo from "./pro_logo.svg";
import G from "./G.svg";
import G_W from "./G-W.svg";
import map_imge from "./map_imge.svg";
// top-nav
import sms from "./sms.svg";
import showRadius from "./show-radius.svg"
import hide from "./hide.svg";


// bottom-nav
import maximize from "./maximize.svg"
import info from "./info.svg"
import note from "./note.svg"
import export_note from "./export-note.svg"
import close_circle from "./close-circle.svg"
import gravity from "./gravity.svg";
// import filters from "./filters.svg";


// side-nav
import showall from "./show-all.svg"
import showallActive from "./show-all-active.svg"
import landmarksActive from "./landmarksActive.svg"
import landmarks from "./landmarks.svg"
import roadsActive from "./roadsActive.svg"
import roads from "./roads.svg"
import buildingActive from "./building.svg"
import building from "./building-off.svg"

// icons filter
import filter from "./icon-filter.svg";
import settingFilter from "./setting-filter.svg";
import search from "./search.svg";
import arrowDropdown from "./arrow-down.svg";
import arrowDropdownWhite from "./arrow-down-white.svg";




// icons card unit
import bed from "./bed.svg"
import bathroom from "./bathroom.svg"
import saleable_area from "./saleable-area.svg"
import direction from "./direction.svg";
import land_area from "./land-area.svg"
import builtUp_area from "./builtUp-area.svg"


// icons InterActiveTour - tour
import zoomIn from "./zoom-in.svg"
import zoomOut from "./zoom-out.svg"
import restart from "./restart.svg"






import built1 from "./build1.jpg"
import built2 from "./build2.jpeg"




import imgspin from "./0001.jpg"



// form 
import X_form from "./X-form.svg"
export const assets = {
    logo,
    G,
    G_W,
    map_imge,
    sms,
    showRadius,
    hide,
    maximize,
    info,
    note,
    export_note,
    close_circle,
    gravity,
    showall,
    showallActive,
    landmarksActive,
    landmarks,
    roadsActive,
    roads,
    buildingActive,
    building,




    filter,
    settingFilter,
    search,
    arrowDropdown,
    arrowDropdownWhite,
    bed,
    bathroom,
    saleable_area,
    direction,
    land_area,
    builtUp_area,





    zoomIn,
    zoomOut,
    restart,

    built1,
    built2,

    imgspin,

    X_form,
};